
import Vue from "vue";
export default Vue.extend({
  name: "Logout",
  mounted: function () {
    localStorage.removeItem("jwt-token");
    localStorage.removeItem("currentUser");
    window.location.href = "/my-account";
  },
});
